import { render, staticRenderFns } from "./PrinterSettingsForm.vue?vue&type=template&id=4b61a9f3&"
import script from "./PrinterSettingsForm.vue?vue&type=script&lang=js&"
export * from "./PrinterSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports